<template>
  <div class="overlay-rows-container">
    <div
      v-if="inExpansionPanel"
      data-testid="overlay-rows-expansion-panel-container"
    >
      <v-expansion-panels
        v-model="panel"
        variant="accordion"
      >
        <v-expansion-panel elevation="0">
          <v-expansion-panel-title class="subheading">
            Overlays
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <slot />
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div
      v-else
      data-testid="overlay-row-single-container"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OverlayRowsContainer',
  props: {
    inExpansionPanel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      panel: 0, // index of the panel to be opened by default
    };
  },
};
</script>

<style lang="scss" scoped>
// eslint-disable vue-scoped-css/no-unused-selector
.v-expansion-panel {
  .v-expansion-panel-title {
    padding: 0;
    :deep(.v-expansion-panel-title__overlay){
      opacity: 0;
    }
  }
  .v-expansion-panel-text {
    :deep(.v-expansion-panel-text__wrapper) {
      padding: 0px;
    }
  }
}
</style>
